<template>
  <div>
    <div class="configuration-holder">
      {{ value.configuration_type.name }}
      <span
        v-if="
          !isEditable && value.configuration_type.type === 'boolean'
        "
        class="configuration-span"
        >{{ value.value === "1" ? "Yes" : "No" }}</span
      >
      <toggle-switch
        v-if="isEditable && value.configuration_type.type === 'boolean'"
        v-on:input="updateVueModelForSwitcher($event, value)"
        v-bind:id="value.id"
        v-bind:name="value.name"
        v-bind:value="value.value === '1' ? true : false"
      ></toggle-switch>

      <span
        v-if="
          !isEditable && value.configuration_type.type === 'integer'
        "
        class="configuration-span"
      >
        {{ value.value }}
      </span>
      <input
        class="configuration-number-input"
        type="number"
        min="0"
        v-if="isEditable && value.configuration_type.type === 'integer'"
        v-on:input="updateVueModelForNumber($event, value)"
        v-bind:value="value.value"
      />
    </div>
    <div
      class="configuration-information"
      v-if="value.configuration_type.type === 'integer'"
    >
      <span class="configuration-span">
        <i>
          {{ valueLabel }} {{ value.usedCount ? value.usedCount + "/" : "0/" }}
          {{ value.value }}
        </i></span
      >
    </div>
  </div>
</template>

<script>
export default {
    props: {
        isEditable: {
            type: Boolean,
            default: false
        },
        value: {
            required: true,
            type: Object
        },
        valueLabel: {
            required: false,
            type: String,
            default: ''
        }
    },
    methods: {
        updateVueModelForSwitcher: function($event, configuration) {
            configuration.value = $event ? '1' : '0';
        },

        updateVueModelForNumber: function($event, configuration) {
            if (configuration.usedCount && configuration.usedCount > $event.target.value) {
                return false;
            }
            configuration.value = parseInt($event.target.value);
        },
    }
};
</script>

<style scoped>

    .configuration-holder {
        height: 28px;
        line-height: 28px;
    }
    .configuration-span {
        font-weight: bold;
    }

    .configuration-number-input {
        width: 40px;
        text-align: center;
    }
</style>
